module.exports = __webpack_public_path__ + "static/media/title_and_abstract_workflow.b25c9d7a.svg";